import { EntityDefinition } from '@/types/crud';

export const navigationNodeEntity: EntityDefinition = {
  name: 'navigation-node',
  displayName: 'Navigation Nodes',
  displayNameSingular: 'Navigation Node',
  apiEndpoint: '/navigation/nodes',

  idField: 'id',
  nameField: 'display_name',
  fields: [
    {
      key: 'node_code',
      label: 'Node Code',
      type: 'text',
      required: true,
      placeholder: 'Enter node code (e.g., CREATE_USER)',
      validation: {
        minLength: 2,
        maxLength: 50,
        pattern: '^[A-Z_]+$'
      }
    },
    {
      key: 'screen_id',
      label: 'Screen',
      type: 'select',
      required: true,
      placeholder: 'Select screen',
      options: [] // Will be populated dynamically
    },
    {
      key: 'display_name',
      label: 'Display Name',
      type: 'text',
      required: true,
      placeholder: 'Enter display name',
      validation: {
        minLength: 2,
        maxLength: 100
      }
    },
    {
      key: 'description',
      label: 'Description',
      type: 'textarea',
      required: false,
      placeholder: 'Enter node description',
      validation: {
        maxLength: 500
      }
    },
    {
      key: 'action_type',
      label: 'Action Type',
      type: 'select',
      required: true,
      placeholder: 'Select action type',
      options: [
        { value: 'READ', label: 'Read' },
        { value: 'CREATE', label: 'Create' },
        { value: 'UPDATE', label: 'Update' },
        { value: 'DELETE', label: 'Delete' },
        { value: 'EXECUTE', label: 'Execute' },
        { value: 'APPROVE', label: 'Approve' },
        { value: 'EXPORT', label: 'Export' },
        { value: 'IMPORT', label: 'Import' },
        { value: 'ARCHIVE', label: 'Archive' },
        { value: 'CONFIGURE', label: 'Configure' }
      ]
    },
    {
      key: 'resource_type',
      label: 'Resource Type',
      type: 'select',
      required: true,
      placeholder: 'Select resource type',
      options: [
        { value: 'USER', label: 'User' },
        { value: 'ROLE', label: 'Role' },
        { value: 'TENANT', label: 'Tenant' },
        { value: 'KPI', label: 'KPI' },
        { value: 'TRANSFORMATION', label: 'Transformation' },
        { value: 'PROCESS', label: 'Process' },
        { value: 'REPORT', label: 'Report' },
        { value: 'DASHBOARD', label: 'Dashboard' },
        { value: 'SYSTEM', label: 'System' },
        { value: 'NAVIGATION', label: 'Navigation' }
      ]
    },
    {
      key: 'resource_id',
      label: 'Resource ID',
      type: 'text',
      required: true,
      placeholder: 'Enter resource ID',
      validation: {
        minLength: 1,
        maxLength: 100
      }
    },
    {
      key: 'sort_order',
      label: 'Sort Order',
      type: 'number',
      required: true,
      placeholder: 'Enter sort order',
      defaultValue: 0,
      validation: {
        min: 0
      }
    },
    {
      key: 'is_active',
      label: 'Active',
      type: 'boolean',
      required: true,
      defaultValue: true
    },
    {
      key: 'is_system_node',
      label: 'System Node',
      type: 'boolean',
      required: true,
      defaultValue: false
    }
  ],
  tableColumns: [
    { key: 'node_code', label: 'Node Code', sortable: true },
    { key: 'display_name', label: 'Display Name', sortable: true },
    { key: 'description', label: 'Description', sortable: false },
    { key: 'action_type', label: 'Action Type', sortable: true },
    { key: 'resource_type', label: 'Resource Type', sortable: true },
    { key: 'resource_id', label: 'Resource ID', sortable: true },
    { key: 'sort_order', label: 'Sort Order', sortable: true },
    { key: 'is_active', label: 'Active', sortable: true },
    { key: 'created_at', label: 'Created', sortable: true }
  ],
  searchFields: ['node_code', 'display_name', 'description', 'action_type', 'resource_type'],
  defaultSort: { field: 'sort_order', direction: 'asc' },
  copyable: true,
  deletable: true
};
